import { render, staticRenderFns } from "./PreviaStudioAviso.vue?vue&type=template&id=11c3e32a&scoped=true&"
import script from "./PreviaStudioAviso.vue?vue&type=script&lang=js&"
export * from "./PreviaStudioAviso.vue?vue&type=script&lang=js&"
import style0 from "./PreviaStudioAviso.vue?vue&type=style&index=0&id=11c3e32a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c3e32a",
  null
  
)

export default component.exports